/* Visar footern på sidan */
import React from "react";
import Version from "./Version";
class Footer extends React.Component {

    render() {
        let mode = "web";
        if (window.matchMedia('(display-mode: standalone)').matches) {
            mode = "sa";
        }
        return (
            <div
                style={{
                    color: "grey",
                    fontSize: "75%",
                    fontStyle: "italic"
                }}>
                <hr />
                <a href='https://kjell.haxx.se/'>Copyright Kjell.Ericson@haxx.se</a>.
                <br />
                {Version}
                &nbsp;&nbsp;
                (ls: {localStorage.length})
                ({mode})
                {this.props.date ?
                    <> ({this.props.date})</>
                    :
                    <></>
                }
            </div>
        )
    }
}


export default Footer;